import React from "react";
import Slider from "react-slick";
import OverviewSecTitle from "../../common/overview_sec_title";
import TopUniBox from "../../common/top_uni_box";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./study_overview_top_rank.module.scss";
import UniThumbGridBox from "../../university/components/uni_thumb_grid_box";

export const StudyOverviewTopRank = ({ universities }) => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1921,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 700,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };

  return (
    <section>
      <div className="container">
        <div className={styles.top_rank}>
          <OverviewSecTitle
            title="Top Universities & Colleges in Australia - Ranking, Fees & Requirement"
            description="A total of 420501 international students enrolled in 140 higher
          education institutions in Australia across various courses. The major
          highlights are shown below"
          />

          <div className={`${styles.top_box_container} top-box-container`}>
            <Slider {...settings}>
              {universities?.slice(0, 10).map((university, i) => (
                <UniThumbGridBox
                  key={university.id}
                  universityLink={`/study/${university?.country?.slug}/university/${university?.slug}`}
                  name={university?.name}
                  featuredImage={university?.featuredImage?.src}
                  featuredImageAlt={university?.featuredImage?.alt}
                  logo={university?.logo?.src}
                  logoAlt={university?.logo?.alt}
                  address={university?.address}
                  city={university?.city?.name || "City"}
                  state={university?.state?.name || "State"}
                  country={university?.country?.name || "Country"}
                  universityType={university.universityType}
                  estd={university?.estd}
                  courseLink={`/study/${university?.country?.slug}/university/${university?.slug}/courses`}
                  courseNumber={university.course.length}
                />
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudyOverviewTopRank;
